var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tour',{attrs:{"name":"exampleMode","steps":_vm.steps,"callbacks":_vm.callbacks,"options":{
    highlight: true,
    enabledNavigationKeys: {
      ESCAPE: false,
      ARROW_RIGHT: true,
      ARROW_LEFT: false,
    },
    labels: {
      buttonPrevious: 'Fast-forward to results',
      buttonSkip: 'End example',
      buttonNext: 'Next',
      buttonStop: 'Finish',
    },
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }